import { useMutation } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { useChatWebsocketContext } from 'chat/websocket/context'
import { isEmpty } from 'lodash'

export function useCreateReadReceipts(
  conversationId: string,
  sendReadByCountUpdates = false
) {
  const { server } = useServer()
  const { sendWebsocketMessage } = useChatWebsocketContext()
  return useMutation({
    mutationFn: createReadReceipts,
    onSuccess: async (event, variables) => {
      if (sendReadByCountUpdates && !isEmpty(event)) {
        sendWebsocketMessage({
          action: 'updateReadByCountEvent',
          readByCountUpdateEvent: {
            userIdMessageIdsMap: event,
            conversationId,
          },
        })
      }
    },
  })

  function createReadReceipts() {
    return server.post<{ [key: string]: string[] }>(
      `/v2/chat/conversations/${conversationId}/read_receipts`,
      {}
    )
  }
}
